<template>
  <div class="service-box">
    <div
      class=""
      id="dialog-list"
      v-loading="loading"
      :element-loading-text="loadintText"
      :class="[sourceCode === 'aisino' ? 'aisino-dialog-list' : 'dialog-list']"
    >
      <div class="toast-box" v-if="REPLY">
        <div class="toast">
          <div class="toast-content">
            <p>{{REPLYCONTENT}}</p>
          </div>
        </div>
      </div>
      <div class="toast-box" v-if="WORK">
        <div class="toast">
          <div class="toast-content">
            <p>{{workContent}}</p>
          </div>
        </div>
      </div>
      <div v-if="loginStatus === false" class="btn-login">
        <button class="el-button" @click="login()">请登录后查看</button>
      </div>
      <div v-if="loginStatus !== false" class="more" @click="more('/record')">
        <p>查看更多></p>
      </div>
      <chatCard
        v-for="(item,index) in list"
        :key="index"
        :item="item"
        :index="index"
        @cxsend="cxsend"
      />
    </div>
    <!-- 底部工具 -->
    <!-- <div class="bottom-part-box">
      <div class="bottom-part-content">
        <div class="part-item send-content">
          <el-input
            type="text"
            class="send-content-input"
            :placeholder="[isVip === 1 ? '请输入您的问题' : '请先购买会员']"
            v-model="textarea"
            maxlength="500"
            :disabled="isVip === 0"
          ></el-input>
        </div>
        <div class="part-item">
          <el-button v-if="isVip === 1" type="primary" class="btn-send" @click="tosend()">发送</el-button>
          <el-button v-if="isVip === 0" type="primary" class="btn-send" @click="buyVip()">购买会员</el-button>
        </div>
      </div>
    </div>-->
    <div class="send-content">
      <el-input
        type="textarea"
        :autosize="{ minRows: 3, maxRows: 20 }"
        :placeholder="
          this.$store.state.userInfo.nickname != undefined
            ? '请输入您的问题'
            : '登录之后才能提问问题呦！'
        "
        v-model="textarea"
        :disabled="
          ISVIP.vip === 0 || this.$store.state.userInfo.nickname != undefined
            ? false
            : true
        "
      ></el-input>
      <el-button
        type="primary"
        size="mini"
        @click="tosend()"
        :disabled="ISVIP.vip === 0 || textarea === '' ? true : false"
        :loading="btnloading"
        v-if="ISVIP.vip === 1"
        >发送</el-button
      >
      <!-- <el-upload
        class="upload-demo"
        drag
        :accept="'image/*'"
        :on-success="handlePreview"
        :before-upload="handleUpload"
        :show-file-list="false"
        v-model="formData"
        action="/api/common/ossUploadFile"
        multiple>
        <i class="el-icon-picture"></i>
      </el-upload> -->
      <el-button type="primary" size="mini" @click="buyVip()" v-if="ISVIP.vip === 0"
        >购买会员</el-button
      >
    </div>
  </div>
</template>

<script>
import chatCard from "@/components/ChatCard.vue";
import { CHAT_API_DATA } from "@/api/chat";
import { API_DATA } from "@/api/index";
import { customRegExp } from "../util/customRegExp";
import config from "@/config";
const mallUrl = config[process.env.NODE_ENV].mallUrl;
const passportUrl = config[process.env.NODE_ENV].passportUrl;

export default {
  name: "service",
  components: {
    chatCard,
  },
  data() {
    return {
      page: 1,
      sending: false,
      loading: false,
      loginStatus: false,
      loadintText: "拼命加载中",
      textarea: "",
      adminUserSig: "",
      userSig: "",
      groupId: "",
      isVip: 0,
      userInfo: {},
      list: [],
      link: "", // 畅捷通购买会员地址
      btnloading: false, //发送的loading
      sourceCode: "",
      tips: {
        replyList: [], // 简单问题
        time: 0, // 超时时间
        timeOut: '', // 超时提示语
        offWork: '', // 下班提示语
      },
      replyContent: '' ,// 锁定提示语
      workContent: '', // 下班提示语
      replyStatus: 0, // 锁定超时状态
      workStatus: false,
      replyTimer: null,
      reply: 0,
      imgMsg: 0,
      formData: '',
      replyList: [],
      getTipsInterval: null,
      isWorkInterval: null
    };
  },
  computed: {
    ISVIP () {
      let expirationTime = this.$store.state.isVip.expirationTime
      let data = {
        vip: this.$store.state.isVip.vip,
        expirationTime: expirationTime === null ? expirationTime : expirationTime.slice(0, 10)
      }
      return data
    },
    USERINFO () {
      return this.$store.state.userInfo
    },
    REPLY () {
      return (this.replyContent !== '' && this.replyContent !== undefined && this.replyContent !== null && this.reply !== 0)
    },
    REPLYCONTENT () {
      return this.replyContent
    },
    WORK () {
      return (this.workContent !== '' && this.workContent !== undefined && this.workContent !== null && this.workStatus)
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.sourceCode = this.$route.query.sourceCode;
    this.userInfo = this.$store.state.userInfo
    this.isVip = this.$store.state.isVip.vip
    this.replyContent = localStorage.getItem('replyContent')
    const val = localStorage.getItem('replyList')
    switch (true) {
      case val === '':
        this.replyList = []
        break
      case val === undefined:
        this.replyList = []
        break
      case val === null:
        this.replyList = []
        break
      default:
        this.replyList = val.split(',')
        break
    }
    if(this.replyList.length !== 0) {
      this.checkLock()
    }
    this.getTipsInterval = setInterval(this.getTips, 3000)
    this.isWorkInterval = setInterval(this.isWork, 3000)
    this.link =
      process.env.NODE_ENV == "development"
        ? "https://inte-store.chanjet.com/purchase?&agentCode=&csparam=&productId=4347&channel=asktax&buyAgain=1&orgId=" +
          this.$route.query.orgId +
          "&successBackBtnLabel=%e5%90%8c%e6%84%8f%e6%89%8b%e6%9c%ba%e5%8f%b7%e6%8e%88%e6%9d%83%e5%b9%b6%e4%bd%93%e9%aa%8c&callback=https%3a%2f%2finte-www.chanjet.com%2fnews%2ff%2f101593.html"
        : "https://store.chanjet.com/wap/purchase?&agentCode=&csparam=&productId=4347&channel=asktax&buyAgain=1&orgId=" +
          this.$route.query.orgId +
          "&successBackBtnLabel=%e5%90%8c%e6%84%8f%e6%89%8b%e6%9c%ba%e5%8f%b7%e6%8e%88%e6%9d%83%e5%b9%b6%e4%bd%93%e9%aa%8c&callback=https%3a%2f%2fwww.chanjet.com%2fnews%2ff%2f102658.html";
  },
  methods: {
    //初始化
    init() {
      this.loginStatus = true;
      this.loading = true;
      this.getAdminUserSig();
      this.getTips()
      this.isWork()
    },
    // 获取上传图片的url
    handlePreview (file) {
      console.log(file)
      this.formData = file.url
      this.imgMsg = 1
      this.tosend()
    },
    //
    handleUpload (file) {
      if (this.groupId === '' || this.groupId === undefined || this.groupId === null) {
          this.init()
          return false
			} else {
        return file
      }
    },
    // 获取提示语
    getTips () {
      CHAT_API_DATA.getTips().then((res) => {
        if (res.code === 401) {
          clearInterval(this.getTipsInterval)
        } else {
          res.data.forEach(item => {
            switch (item.type) {
              case 0:
                this.tips.replyList.push(item)
                break
              case 4:
                this.tips.time = item.content
                break
              case 5:
                this.tips.timeOut = item.content
                break
              case 6:
                this.tips.offWork = item.content
                break
              default:
                break
            }
          })
        }
      })
    },
    // 获取服务状态
    isWork() {
      CHAT_API_DATA.isWork().then((res) => {
        if (res.code === 401) {
          clearInterval(this.isWorkInterval)
        } else {
          this.workStatus = res.data
          if (res.data) {
            this.workContent = this.tips.offWork
          } else {
            this.workContent = ''
          }
        }
      })
    },
    //点击发送
    tosend() {
      if (this.groupId === '' || this.groupId === undefined || this.groupId === null) {
					this.init()
			} else if (this.textarea === "" && this.formData === '') {
        this.$message({
          showClose: true,
          message: "请输入您的问题",
          type: "warning",
        });
      } else {
        this.sending = true;
        this.btnloading = true;
        let createTime = this.customeTime();
        let data = {};
        let remessage = customRegExp(this.textarea);
        data.message = this.imgMsg === 1 ? this.formData : remessage;
        data.messageType = 0;
        data.groupId = this.groupId;
        data.userType = 0;
        data.replyed = 0;
        data.userLock = 0;
        data.imgMsg = this.imgMsg
        CHAT_API_DATA.sendMessage(data)
          .then((res) => {
            if (res.status == 0) {
              var timemax = Math.abs(new Date().getMinutes() - this.fz);
              var time = new Date();
              if (parseInt(time.getMinutes()) < parseInt(10)) {
                this.times = time.getHours() + ":0" + time.getMinutes();
              } else {
                this.times = time.getHours() + ":" + time.getMinutes();
              }
              if (parseInt(timemax) >= parseInt(1)) {
                this.list.push({
                  userType: -1,
                  time: this.times,
                });
                this.fz = time.getMinutes();
              }
              let MsgContent = {
                id: res.data,
                createTime: createTime,
                message: this.imgMsg === 1 ? this.formData : remessage,
                messageLock: 0,
                userId: parseInt(this.userInfo.id),
                messageType: 0,
                userType: 0,
                replyed: 0,
                userLock: 0,
                imgMsg: this.imgMsg,
              };
              this.list.push(MsgContent);
              this.getinfomsgListWeb(MsgContent);
            } else if (res.status == -1) {
              this.$message({
                showClose: true,
                message: res.msg,
                type: "warning",
              });
            }
          })
          .catch((err) => {
            this.showErr(err);
          });
      }
    },
    //调用websocket发送
    getinfomsgListWeb(MsgContent) {
      const { tim } = this;
      let message = tim.createTextMessage({
        to: this.groupId,
        conversationType: this.TIM.TYPES.CONV_GROUP,
        payload: {
          text: JSON.stringify(MsgContent),
        },
      });
      // 2. 发送消息
      var that = this;
      if (this.imgMsg === 0){
        that.textarea = "";
      }
      this.formData = ''
      that.imgMsg = 0
      let promise = tim.sendMessage(message);
      promise
        .then(function (imResponse) {
          // 发送成功
          that.btnloading = false;
          console.log("发送成功");
          console.log(imResponse);
        })
        .catch(function (imError) {
          that.btnloading = false;
          console.log("发送失败");
          for (var i = 0; i < that.list.length; i++) {
            if (MsgContent.id === that.list[i].id) {
              console.log(that.list[i]);
              // that.list[i].errSend = true
              that.$set(that.list[i], "errSend", true);
            }
          }
          that.DelMessage(MsgContent.id);
          console.warn("sendMessage error:", imError);
        });
    },
    //获取聊天记录
    getMessageList() {
      const data = {
        page: this.page,
        limit: 10,
      };
      this.loading = true;
      this.loadintText = "拼命加载中";
      CHAT_API_DATA.getMessageList(data)
        .then((res) => {
          this.loading = false;
          this.list = res.rows.reverse();
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    //获取管理员签名
    getAdminUserSig() {
      let data = {
        num: Math.random(),
      };
      CHAT_API_DATA.getAdminUserSig(data)
        .then((res) => {
          if (res.code === 401) {
            console.log(res);
          } else {
            this.adminUserSig = res.data;
          }
          this.getUserSig()
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    //获取用户签名
    getUserSig() {
      console.log(this.$store.state.userInfo)
      const data = {
        account: "U" + this.userInfo.id,
      };
      CHAT_API_DATA.getUserSig(data)
        .then((res) => {
          if (res.code === 401) {
            console.log(res);
          } else {
            this.userSig = res.data;
            this.importAccount();
          }
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    //导入单个账号
    importAccount() {
      const data = {
        nick: "U" + this.userInfo.mobile,
        faceUrl: "",
      };
      CHAT_API_DATA.importAccount(data)
        .then((res) => {
          this.initListener();
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    //TIM init
    initListener() {
      const { tim } = this;
      tim.setLogLevel(0);
      tim.registerPlugin({
        "cos-js-sdk": this.COS,
      });
      tim.on(this.TIM.EVENT.MESSAGE_RECEIVED, this.onReceiveMessage);
      let promise = tim.login({
        userID: "U" + this.userInfo.id,
        userSig: this.userSig,
      });
      promise
        .then((imResponse) => {
          console.log("登录成功");
          console.log(imResponse.data);
        })
        .catch((imError) => {
          console.warn("login error:", imError);
        });
      this.addGroup();
    },
    //接收消息
    onReceiveMessage(event) {
      console.log("接受的消息", JSON.parse(event.data[0].payload.text));
      let news = JSON.parse(event.data[0].payload.text)
      if (news.messageType === 4) { 
        let listIndex = this.replyList.indexOf(news.id)
        if (listIndex !== -1) {
          this.replyList.splice(listIndex, 1)
          localStorage.setItem('replyList', this.replyList)
        }
        this.reply = 0
        this.replyContent = '',
        localStorage.setItem('replyContent', '')
        clearTimeout(this.replyTimer)
      }
      // 是否当前用户
      if (JSON.parse(event.data[0].payload.text).userId === parseInt(this.userInfo.id)) {
        let replyIndex = this.tips.replyList.findIndex(function (item) {
          return item.id === news.difficulty
        })
        if (news.messageType === 3) {
          this.replyList.push(news.id)
          this.reply = 1
          localStorage.setItem('replyList', this.replyList)
          if (replyIndex !== -1) {
            console.log('show')
            this.replyContent = this.tips.replyList[replyIndex].content
            localStorage.setItem('replyContent', this.replyContent)
          }
          // 是否设置锁定超时定时器
          let val = parseInt(this.tips.time) * 60 * 1000
          console.log(val)
          this.replyTimer = setTimeout(() => {
            this.replyContent = this.tips.timeOut
            localStorage.setItem('replyContent', this.replyContent)
          }, val)
        }
        this.list.push(news);
      // 是否回复当前用户
      } else if(JSON.parse(event.data[0].payload.text).replyUserId === parseInt(this.userInfo.id)) {
        let listIndex = this.replyList.indexOf(news.replyId)
        if (listIndex !== -1) {
          this.replyList.splice(listIndex, 1)
          localStorage.setItem('replyList', this.replyList)
        }
        this.reply = 0
        this.replyStatus = 0
        this.replyContent = '',
        localStorage.setItem('replyContent', '')
        this.list.push(news)
        clearTimeout(this.replyTimer)
			} else {
        this.list.push(news);
      }

      //删除的回调
      if (JSON.parse(event.data[0].payload.text).deleteId) {
        for (let i = 0; i < this.list.length; i++) {
          if (this.list[i].id === JSON.parse(event.data[0].payload.text).id) {
            this.list.splice(i, 1);
          }
        }
      }
      this.userUnRead();
    },
    //加入群
    addGroup() {
      const data = {
        nick: this.userInfo.mobile,
        faceUrl: "",
      };
      this.loading = true;
      this.loadintText = "正在建立连接";
      CHAT_API_DATA.addGroup(data)
        .then((res) => {
          this.loading = false;
          this.groupId = res.data;
          console.log(res)
          this.getMessageList();
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    customeTime() {
      var date = new Date();
      var seperator1 = "-"; //设置成自己想要的日期格式 年/月/日
      var seperator2 = ":"; //设置成自己想要的时间格式 时:分:秒
      var month = date.getMonth() + 1; //月
      var strDate = date.getDate(); //日
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        date.getHours() +
        seperator2 +
        date.getMinutes() +
        seperator2 +
        date.getSeconds();
      return currentdate;
    },
    //未读提醒
    userUnRead() {
      CHAT_API_DATA.userUnRead()
        .then((res) => {
          this.$emit("userUnRead", res.data);
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    //删除接口
    DelMessage(messageId) {
      CHAT_API_DATA.delMessage(messageId)
        .then((res) => {
          console.log(res);
        })
        .catch((err) => {
          this.showErr(err);
        });
    },
    //点击重新发送
    cxsend(item) {
      for (var i = 0; i < this.list.length; i++) {
        if (item.id === this.list[i].id) {
          this.list.splice(i, 1);
        }
      }
      this.textarea = item.message;
      this.tosend();
    },
    more(url) {
      this.$router.push(url + window.location.search);
    },
    //购买会员
    buyVip() {
      if (this.$store.state.cjt === true) {
        // window.location.href = this.link;
        //判断 是否需要跳转后台传递的购买链接  liyanze-分支增加
        let isBuy =  sessionStorage.getItem("cjtIsHavePay");
        if(isBuy == 'yes'){
          let buyUrl =  sessionStorage.getItem("cjtPayUrl"); 
          window.open(buyUrl);
        }else{
          window.open(this.link);
        }
      } else {
        // window.location.href = mallUrl;
        window.open(mallUrl);
      }
    },
    //点击登录
    login() {
      var url = encodeURIComponent(location.href);
      window.location.href = passportUrl + "?client_id=sbw&redirectUrl=" + url;
    },
    // 检查消息锁定状态
    checkLock() {
      CHAT_API_DATA.checkLock(this.replyList).then((res) => {
        let result = res.data
        result.forEach(item => {
          if (item.replyed === 1) {
            let listIndex = this.replyList.indexOf(item.id)
            if (listIndex !== -1) {
              this.replyList.splice(listIndex, 1)
              localStorage.setItem('replyList', this.replyList)
            }
          } else {
            this.reply = 1
          }
        })
      })
		},
    //显示错误
    showErr(err) {
      this.$message({
        showClose: true,
        message: "连接超时，请重试！",
        type: "warning",
      });
      console.log(err);
    },
  },
  watch: {
    //监听list数据置底
    list: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          let contant = this.$el.querySelector("#dialog-list");
          contant.scrollTop = contant.scrollHeight;
        });
      },
    },
    ISVIP: function (val) {
      this.isVip = val
    },
    USERINFO: {
      deep: true,
      handler (val) {
        console.log('事件监听', val)
        this.userInfo = {...val}
      }
    }
  },
};
</script>

<style>
.service-box {
  display: grid;
  grid-template-rows: 1fr auto;
}
.dialog-list {
  margin-top: 20px;
  /* min-height: 500px; */
  /* max-height: 500px; */
  max-height: calc(100vh - 427px);
  min-height: inherit;
  overflow: hidden;
  overflow-y: scroll;
  /* background-color: #f0f5fa; */
}
.dialog-list::-webkit-scrollbar {
  display: none;
}
.btn-login {
  width: 100%;
  text-align: center;
}
.more {
  /* position: sticky; */
  z-index: 999;
  /* top: 8px; */
  width: auto;
  margin: 5px auto;
  text-align: center;
  color: #2270e6;
  cursor: pointer;
}
.more p {
  display: inline-block;
  background-color: #ffffff;
  padding: 15px;
  border-radius: 25px;
  box-shadow: -2px 0 3px -1px #eeeeee, 0 -2px 3px -1px #eeeeee,
    0 2px 3px -1px #eeeeee, 2px 0 3px -1px #eeeeee;
}
.bottom-part-box {
  width: 100%;
  padding: 15px 0;
  border-top: 1px solid #eeeeee;
  border-left: 1px solid #eeeeee;
  border-right: 1px solid #eeeeee;
  border-radius: 15px;
}
.bottom-part-content {
  margin: 0 15px;
  display: grid;
  grid-template-columns: 1fr auto;
}
/* .send-content {
  margin-right: 20px;
} */
.send-content {
  padding: 20px;
  background-color: #fff;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  border-top: solid 1px #d7dadd;
  overflow: hidden;
}
.send-content /deep/.el-textarea__inner {
  border: 0px;
  padding: 0px;
}
.send-content /deep/.el-button {
  float: right;
  width: 80px;
  height: 35px;
  padding: 0px;
  line-height: 35px;
  margin-top: 10px;
  /* background-color: #e5eaef; */
  border-radius: 10px;
  color: #ffffff;
}
/* firefox 兼容 */
.send-content .el-textarea__inner {
  border: 0px;
  padding: 0px;
}
.send-content .el-button {
  float: right;
  width: 80px;
  height: 35px;
  padding: 0px;
  line-height: 35px;
  margin-top: 10px;
  /* background-color: #e5eaef; */
  border-radius: 10px;
  color: #ffffff;
}

.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  color: #000000;
  cursor: not-allowed;
  background-image: none;
  background-color: #ebeef5;
  border-color: #ebeef5;
}
.el-button--primary {
  color: #fff;
  background-color: #2270e6;
  border-color: #2270e6;
}
.toast-box {
  top: 10px;
  text-align: center;
  position: sticky;
  z-index: 999;
  min-width: inherit;
}
.toast {
  position: relative;
  text-align: center;
  /* min-width: 100%; */
  margin: 5px 30px;
  background-color: #D7555B;
  /* border-radius: 20px; */
  box-shadow: 0px 4px 16px 0px rgba(132, 23, 28, 0.56);
}
.toast-content {
  padding: 10px;
  color: #FFFFFF;
  font-size: 14px;
  font-family: 'SourceHanSansCN-Regular';
}
.upload-demo {
  align-self: flex-end;
  float: right;
  margin-right: 10px;
}
.upload-demo /deep/ .el-upload-dragger {
  width: 40px;
  height: 40px;
  font-size: 40px;
  border: none;
}
/* 定制版CSS */
.aisino-dialog-list {
  margin-top: 20px;
  /* min-height: 500px; */
  /* max-height: 500px; */
  max-height: calc(100vh - 337px);
  min-height: calc(100vh - 337px);
  overflow: hidden;
  overflow-y: scroll;
  /* background-color: #f0f5fa; */
}
.aisino-dialog-list::-webkit-scrollbar {
  display: none;
}
</style>
